import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
    setMobileOpen(false);
  };

  const navToPage = (path: string) => {
    navigate(path);
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navItems = [
    { label: "Home", action: () => navToPage("/") },
    { label: "Services", action: () => navToPage("/services") },
    { label: "Portfolio", action: () => navToPage("/portfolio") },
    { label: "About", action: () => navToPage("/about") },
    { label: "Contact", action: () => navToPage("/contact") },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-sm shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="/"
            className="flex items-center gap-2 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              navToPage("/");
            }}
          >
            <img
              src="https://public.readdy.ai/ai/img_res/b1fd4538-34ee-4db1-8102-41d840bea221.png"
              alt="Castillo Painting Inc."
              className="h-10 md:h-12 w-auto"
            />
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={item.action}
                className="text-sm font-medium tracking-wider uppercase text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => navToPage("/contact")}
              className="bg-primary-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get a Quote
            </button>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl text-foreground-950`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-sm border-t border-background-200/70">
          <div className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={item.action}
                className="block w-full text-left text-sm font-medium tracking-wider uppercase text-foreground-700 hover:text-primary-500 transition-colors py-2 cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection("quote")}
              className="w-full bg-primary-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-primary-600 transition-colors text-center cursor-pointer"
            >
              Get a Quote
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}